import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_EXPAND: GlameraIconDefinition = {
  name: 'expand',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-expand-corner glm-expand-corner-tl">
      <path d="M3 8V3h5"></path>
      <path d="M9 9 3 3"></path>
    </g>
    <g class="glm-expand-corner glm-expand-corner-tr">
      <path d="M21 8V3h-5"></path>
      <path d="m15 9 6-6"></path>
    </g>
    <g class="glm-expand-corner glm-expand-corner-bl">
      <path d="M3 16v5h5"></path>
      <path d="m3 21 6-6"></path>
    </g>
    <g class="glm-expand-corner glm-expand-corner-br">
      <path d="M21 16v5h-5"></path>
      <path d="m15 15 6 6"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-expand-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './expand.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ExpandIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_EXPAND;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
